import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Layout
import DashboardLayout from './layouts/DashboardLayout';

// Pages
import SearchPage from './pages/SearchPage';
import DashboardPage from './pages/DashboardPage';
import NewApplicationPage from './pages/NewApplicationPage';
import ApplicationDetailsPage from './pages/ApplicationDetailsPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Standalone Pages (they have their own headers) */}
        <Route path="/" element={<SearchPage />} />
        <Route path="/new-application" element={<NewApplicationPage />} />
        <Route path="/application/:id" element={<ApplicationDetailsPage />} />

        {/* Dashboard Layout (pages that use the sidebar) */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          {/* You could add more dashboard pages here, like /dashboard/settings */}
        </Route>
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
